import { useNavigate, } from 'react-router-dom';

import { Button, ButtonGroup, Box, Divider, Typography } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery';

import { useData } from '../hooks/DataProvider';

import translations from '../scripts/translations';


const Menu = ({ currentPage }) => {

    const { updateLanguage, language } = useData();


    const menu = translations['menu'][language];


    const MenuItems = [
        { code: 'shipments', name: menu.shipments, path: '/shipments', part: 'left', roles: ['admin', 'manager',] },
        { code: 'consolidations', name: menu.consolidations, path: '/consolidations', part: 'left', roles: ['admin', 'manager',] },
        { code: 'documents', name: menu.documents, path: '/documents', part: 'left', roles: ['admin', 'manager',] },
        { code: 'tiers', name: menu.tiers, path: '/tiers', part: 'left', roles: ['admin', 'manager',] },
        // { code: 'main', name: 'Main', path: '/main', part: 'left', roles: ['admin', 'manager', ] },
        { code: 'config', name: menu.settings, path: '/settings', part: 'right', roles: ['admin', 'manager'] },
        { code: 'logout', name: menu.logout, path: '/logout', part: 'right', roles: ['admin', 'manager', 'accounting', 'client'] },
    ]

    const screenSizeIsSmall = useMediaQuery('(min-width:600px)');
    const navigate = useNavigate()

    // const logout = () => {
    //     localStorage.clear()
    //     navigate('/')
    // }

    const role = localStorage.getItem('role')
    const userMenu = MenuItems.filter(item => item.roles.includes(role))
    const leftMenu = userMenu.filter(item => item.part === 'left')
    const rightMenu = userMenu.filter(item => item.part === 'right')
    const leftMenuItems = leftMenu.map(item => (
        <Button
            variant={currentPage === item.code ? 'contained' : 'outlined'}
            key={item.code}
            onClick={() => { navigate(item.path) }}
            sx={{}}
        // disabled={currentPage === item.code}
        >
            {item.name}
        </Button>

    ))
    const rightMenuItems = rightMenu.map(item => (
        <Button variant='outlined' key={item.code} onClick={() => { navigate(item.path) }} >
            {screenSizeIsSmall ? item.name : item.name}
        </Button>
    ))

    const version = process.env.REACT_APP_VERSION || 'V 1.0.10';

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', }}>

                <Box sx={{ my: 2, display: 'flex', gap: 1 }}>
                    {leftMenuItems}
                </Box>

                <Box sx={{ my: 2, display: 'flex', gap: 1 }}>
                     <Box sx={{ display:'flex', alignItems: 'center', mr:3 }}>

                        <Typography variant='caption' style={{ color: 'gray', fontSize: '0.8rem' }}>
                            {version}
                        </Typography>
                    </Box>
                    <ButtonGroup
                        disableElevation
                        variant='outlined'
                    // aria-label="Disabled button group"
                    >
                        <Button onClick={() => updateLanguage('fr')} disabled={language === 'fr' ? true : false} >FR</Button>
                        <Button onClick={() => updateLanguage('en')} disabled={language === 'en' ? true : false} >EN</Button>
                    </ButtonGroup>
                    {rightMenuItems}
                </Box>


            </Box>


            <Divider sx={{ my: 2 }} />
        </>

    )
}

export { Menu }